/**
 * Uplifted pieces of `config/index.js` (apps/web + apps/mobile).
 *
 * Mirrors the app file (CLAUDE.md → "Uplifting a module's dependencies") and holds only what
 * has actually been moved: the two API path segments `utils/apiService` needs. Both are plain
 * string literals that are IDENTICAL in the two apps, so they are shared and need no split —
 * `packages/core/config/` is the folder, this is its no-split `index.ts` (ledger:
 * "ALWAYS A FOLDER"). `config/endpoints/` is its sibling, mirroring `config/endpoints.js`.
 *
 * 🔴 **`RISTA_API_URL` and `RECOMMENDATION_ENGINE_URL` deliberately DO NOT live here.** They are
 * the two config values that are genuinely per-app and per-BUILD: web reads
 * `process.env.REACT_APP_*`, which webpack INLINES at build time, and mobile derives its
 * `baseURL` at runtime from `react-native-config`. Those come through the effects bridge
 * (`getEnv("ristaApiUrl")` / `getEnv("recommendationEngineUrl")`), which is why only these two
 * literals moved. Putting a constant string through the bridge would grow a seam whose whole
 * point is to shrink.
 */

/** Base path for the "br" (branch) service group. Identical in both apps. */
export const RISTA_CUSTOM_URL = "business/services/br/";

/** Base path for the "bn" (business) service group — the default for every request. */
export const RISTA_COMMON_URL = "business/services/bn/";
